<ion-header>
  <ion-toolbar color="medium">
    <ion-title>BUSCAR USUARIO</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="modalCtrl.dismiss(null)">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-margin">
  <ion-searchbar
      #inputArea
      [animated]="true"
      color="warning"
      placeholder="Buscar usuario"
      (ionInput)="getItems($event)"
  ></ion-searchbar>
  @if (items?.length > 0) {
    <ion-list lines="none">
      @for (item of items; track item.id) {
        <ion-item (click)="modalCtrl.dismiss(item)" [detail]="false" color="primary" class="kblab-text-bold point">
          <ion-label>{{item.nombreCompleto}}</ion-label>
        </ion-item>
      }
    </ion-list>
  }
</ion-content>
